import React from 'react';
import PropTypes from 'prop-types';

import './_batchMessageVariables.scss';

const BatchMessageVariables = ({ variables, applyVariable }) => {

  return (
    <div className="batchMessageVariables">
      <p className="batchMessageVariables-title">Variables:</p>
      <div className="batchMessageVariables-list">
        {variables.map(variable => (
          <p
            key={variable.key}
            className="batchMessageVariables-list__item"
            onMouseDown={e => e.preventDefault()}
            onClick={() => applyVariable(variable.key)}
          >
            {variable.key}
          </p>
        ))}
      </div>
    </div>
  );
};

BatchMessageVariables.propTypes = {
  variables: PropTypes.array,
  applyVariable: PropTypes.func
};

export default BatchMessageVariables;
